import http_request from './http_request'
import config from 'config'
import agentTypes from 'helpers/enums/agentTypes'
import externalApiTypes from 'helpers/enums/externalApiTypes'
import superagentPromisePlugin from 'superagent-promise-plugin'
import http_agent from './http_agent'

function getSlideData(jwt, uid) {
	return http_request
		.get(`${config.slide_api_gateway}slides/${uid}/getSlideByExternal`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function getInteractiveVideoData(jwt, uid, type) {
	return http_request.get(`${config.slide_api_gateway}slides/media/${uid}/${type}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function getAssetVideo(uid, jwt) {
	return http_request
		.get(`${config.slide_api_gateway}assets/videos/${uid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function getAssetImage(uid, jwt) {
	return http_request
		.get(`${config.slide_api_gateway}assets/images/${uid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function updateMedia(uid, jwt, duration, credits) {
	return http_request
		.put(`${config.slide_api_gateway}slides/media/${uid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			duration,
			credits,
		})
}

function patchUpdateMedia(mediaUid, jwt) {
	return http_request
		.patch(`${config.slide_api_gateway}slides/media/${mediaUid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			asset: {
				uid: '',
			},
			posterUid: '',
			duration: 0,
			credits: '',
		})
}

function createMediaAsset(uid, jwt, videoId) {
	return http_request
		.post(`${config.slide_api_gateway}slides/media/${uid}/asset`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ sourceId: videoId })
}

function saveSlide(externalUid, jwt) {
	return http_request
		.put(`${config.slide_api_gateway}slides/external/${externalUid}/save`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function createInteractiveVideo(folderUid) {
	return http_request.post(`${config.api}interactive_video`)
		.send({ folderUid })
}

function getPresentation(presentationId) {
	return http_request
		.get(`${config.api}presentation/${presentationId}`)
		.send()
}

function savePresentation(jwt, name, subjectId, gradeIds, presentationId) {
	return http_request
		.patch(`${config.api}presentation/${presentationId}`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			name,
			subjectId,
			gradeIds,
			validateTitle: true,
		})
}

function createOeqSubmission(
	jwt,
	mediaSessionUid,
	questionUid,
	participantUid,
	value
) {
	return http_request
		.post(`${config.video_session_api_gateway}question/media/
			sessions/${mediaSessionUid}/oeqs/${questionUid}/
			participants/${participantUid}/submit`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			value,
		})
}

function createMcqSubmission(
	jwt,
	mediaSessionUid,
	questionUid,
	participantUid,
	answerUids
) {
	return http_request
		.post(`${config.video_session_api_gateway}question/media/
			sessions/${mediaSessionUid}/mcqs/${questionUid}/
			participants/${participantUid}/submit`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			answerUids,
		})
}

function findOeqSubmissions(
	jwt,
	mediaSessionUid,
	participantUid,
	questionUids
) {

	return http_request
		.get(`${config.video_session_api_gateway}question/media/
			sessions/${mediaSessionUid}/oeqs/submissions/
			participants/${participantUid}?questionUids=${questionUids.toString()}`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function findMcqSubmissions(
	jwt,
	mediaSessionUid,
	participantUid,
	questionUids
) {
	return http_request
		.get(`${config.video_session_api_gateway}question/media/
			sessions/${mediaSessionUid}/mcqs/submissions/
			participants/${participantUid}?questionUids=${questionUids.toString()}`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function shareMcqSolution(
	jwt,
	mediaSessionUid,
	questionUid,
) {
	return http_request
		.post(`${config.video_session_api_gateway}sessions/media/${mediaSessionUid}/mcqs/${questionUid}/
			share`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function unshareMcqSolution(
	jwt,
	mediaSessionUid,
	questionUid,
) {
	return http_request
		.post(`${config.video_session_api_gateway}sessions/media/${mediaSessionUid}/mcqs/${questionUid}/
			unshare`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function shareOeqParticipantSubmission(
	jwt,
	mediaSessionUid,
	questionUid,
	participantUid,
) {
	return http_request
		.post(`${config.video_session_api_gateway}sessions/media/
			${mediaSessionUid}/oeqs/${questionUid}/
			share`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({participantUid})
}

function unshareOeqParticipantSubmission(
	jwt,
	mediaSessionUid,
	questionUid,
	participantUid,
) {
	return http_request
		.post(`${config.video_session_api_gateway}sessions/media/
			${mediaSessionUid}/oeqs/${questionUid}/
			unshare`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({participantUid})
}

function addBreakpoint(uid, jwt, startTime, endTime) {
	return http_request
		.post(`${config.slide_api_gateway}slides/media/${uid}/breakpoint`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ startTime, endTime })
}

function saveBreakpoint(mediaUid, breakpointUid, jwt, breakpointData) {
	return http_request
		.put(`${config.slide_api_gateway}slides/media/${mediaUid}/breakpoint/${breakpointUid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send(breakpointData)
}

function addBreakpointActivity(
	uid,
	jwt,
	breakpointUid,
	activityUid,
	activityType,
) {
	return http_request
		.post(
			`${config.slide_api_gateway}slides/media/${uid}/
			breakpoint/${breakpointUid}/activity/${activityUid}`
		)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ activityType })
}

function saveBreakpointActivity(
	mediaUid,
	breakpointActivityUid,
	activityUid,
	jwt,
) {
	return http_request
		.put(
			`${config.slide_api_gateway}slides/media/${mediaUid}/
			breakpoint-activity/${breakpointActivityUid}`
		)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			activityUid,
		})
}

function duplicateQuestion(
	jwt,
	activityUid,
) {
	return http_request
		.post(
			`${config.slide_api_gateway}questions/${activityUid}/duplicate`
		)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function deleteBreakpoint(mediaUid, breakpointUid, jwt) {
	return http_request
		.delete(`${config.slide_api_gateway}slides/media/${mediaUid}/breakpoint/${breakpointUid}`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function linkAsset(uid, jwt, assetUid, assetPosterUid) {
	return http_request
		.put(`${config.slide_api_gateway}slides/media/${uid}/asset`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ assetUid, assetPosterUid })
}

function linkPosterAsset(uid, jwt, assetPosterUid) {
	return http_request
		.put(`${config.slide_api_gateway}slides/media/${uid}/asset/image`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ assetPosterUid })
}

function linkBinaryAsset(uid, jwt, assetBinaryUid, assetBinaryType) {
	return http_request
		.put(`${config.slide_api_gateway}slides/media/${uid}/asset/binary`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ assetBinaryUid, assetBinaryType })
}

function publishInteractiveVideo(externalUID) {
	return http_request
		.put(`${config.api}presentation/custom_slides/${externalUID}/publish`)
		.send()
}

function getInteractiveVideoLesson(externalUID, jwt) {
	let headers = {}
	if (jwt) {
		headers = {
			jwt,
			'x-api-key': externalApiTypes.EXTERNAL_SLIDES_UID,
		}
	}
	return http_request
		.get(`${config.api}custom_slide_presentations/${externalUID}`)
		.withHeaders(headers)
		.send()
}

function getNotifications(jwt) {
	let headers = {}
	if (jwt) {
		headers = {
			jwt,
			'x-api-key': externalApiTypes.EXTERNAL_SLIDES_UID,
		}
	}
	return http_request
		.get(`${config.api}interactive_video/notifications`)
		.withHeaders(headers)
		.send()
}

function getPreviewData(
	jwt,
	mediaUid,
) {
	return http_request
		.get(`${config.video_session_api_gateway}sessions/media/${mediaUid}/preview`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function copySettings(presentationStoreParentUid, uid, jwt, title) {
	return http_request
		.put(`${config.api}presentation/custom_slides/${uid}/copy_settings`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ presentationStoreParentUid, title })
}

function copyMedia(uidDestination, uidOrigin, jwt) {
	return http_request
		.put(`${config.slide_api_gateway}slides/media/${uidDestination}/copy`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ originalUid: uidOrigin })
}

function getHandouts(uid, jwt) {
	return http_request
		.get(`${config.slide_api_gateway}slides/media/${uid}/handouts`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function saveStoreParentId(presentationStoreParentUid, uid, jwt) {
	return http_request
		.put(`${config.api}custom_slides/${uid}/from_store`)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ presentationStoreParentUid })
}

function updateEntity(mediaUid, jwt, entity) {
	return http_request
		.patch(`${config.slide_api_gateway}slides/media/${mediaUid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send(entity)
}

function checkStorage(externalUid, size, jwt) {
	return http_request
		.get(`${config.slide_api_gateway}slides/media/check-storage`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({ externalUid, size})
}

function createSession(externalUid, jwt, userRole) {
	return http_request
		.get(`${config.video_session_api_gateway}slides/${externalUid}/session/${userRole}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			jwt,
		})
}

function getCaptionList(videoId) {
	const headers = {
		'Content-type': null,
		subtype: null,
		npversion: null,
	}

	return http_agent.get(`https://video.google.com/timedtext?type=list&v=${videoId}`)
		.send()
		.set(headers)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			return response
		})
}

function saveTrim(mediaUid, jwt, trimStart, trimEnd) {
	return http_request
		.patch(`${config.slide_api_gateway}slides/media/${mediaUid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send({
			trimStart,
			trimEnd,
		})
}

function getParticipantSessionState(mediaSessionUid, participantUid, jwt) {
	return http_request
		.get(`${config.video_session_api_gateway}sessions/media/${mediaSessionUid}/participant/${participantUid}/state`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

export default {
	getSlideData,
	getInteractiveVideoData,
	getAssetVideo,
	updateMedia,
	patchUpdateMedia,
	createMediaAsset,
	saveSlide,
	createInteractiveVideo,
	getPresentation,
	savePresentation,
	createOeqSubmission,
	createMcqSubmission,
	findOeqSubmissions,
	findMcqSubmissions,
	shareMcqSolution,
	unshareMcqSolution,
	shareOeqParticipantSubmission,
	unshareOeqParticipantSubmission,
	addBreakpoint,
	saveBreakpoint,
	linkAsset,
	linkPosterAsset,
	linkBinaryAsset,
	publishInteractiveVideo,
	addBreakpointActivity,
	saveBreakpointActivity,
	getAssetImage,
	getInteractiveVideoLesson,
	getNotifications,
	duplicateQuestion,
	deleteBreakpoint,
	getPreviewData,
	copySettings,
	copyMedia,
	getHandouts,
	saveStoreParentId,
	updateEntity,
	checkStorage,
	createSession,
	getCaptionList,
	saveTrim,
	getParticipantSessionState,
}
